import { Select as UISelect } from '@treams/treams-ui';
import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';
import ConfigurationFieldEdit from './ConfigurationFieldEdit';

function Select(props: {
	field: graphql.ConnectorConfigFieldSelect;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => void;
}) {
	const { t } = useTranslation();
	const options =
		props.field.options?.map((option) => ({
			title: option.label,
			value: option.value,
		})) ?? [];

	const selectedValue = props.change?.selectValue ?? props.field.value;

	return (
		<UISelect
			options={options}
			selectedOption={options.find(({ value }) => value === selectedValue)}
			onChange={(selectValue) => {
				props.onChange({ selectValue });
			}}
			placeholder={t('connectors.settings.configuration.select.empty')}
		/>
	);
}

export default function ConfigurationFieldSelect(props: {
	connectorType: graphql.ConnectorType;
	field: graphql.ConnectorConfigFieldSelect;
	autoFocus?: boolean;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => void;
}) {
	const disabledValue = props.field.value ?? '—';

	return (
		<ConfigurationFieldEdit
			{...props}
			editingChildren={(field) => (
				<Select
					field={field as graphql.ConnectorConfigFieldSelect}
					change={props.change}
					onChange={props.onChange}
				/>
			)}
		>
			<UISelect
				disabled
				selectedValue={disabledValue}
				options={[{ value: disabledValue, title: disabledValue }]}
				onChange={() => {}}
			/>
		</ConfigurationFieldEdit>
	);
}
